









































































































import Component from "vue-class-component";
import CatalogCompensationRepository from "@/repositories/zero-waste/CatalogCompensationRepository";
import ViewList from "@/views/List.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";
import DatePickerSearch from "@/components/forms/search/DatePickerSearch.vue";
import WeekSearch from "@/components/forms/search/WeekSearch.vue";
import _ from "lodash";
import { Getter } from "vuex-class";
import EventBus from "front-component/EventBus";
import {Watch} from "vue-property-decorator";
import CatalogCompensationList from "@/components/zero-waste/list/List.vue";
import CatalogCompensationForm from "@/components/forms/zero-waste/CatalogCompensationForm.vue";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import SelectGroupSearch from "@/components/forms/search/SelectGroupSearch.vue";
import ValidationCampaignForm from "@/components/forms/zero-waste/ValidationCampaignForm.vue";
import MultipleSelectSearch from "@/components/forms/search/MultipleSelectSearch.vue";
import * as Constants from "@/Constants";
import Http from "front-component/Http";
import FileRepository, { Document } from "@/repositories/FileRepository";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import { OptionOwner } from "@/mixins/components/CommonSelectOwnerMixin";
import moment from "moment";

const components = {
    KeywordSearch,
    DatePickerSearch,
    WeekSearch,
    SelectSearch,
    SelectGroupSearch,
    MultipleSelectSearch,
    CatalogCompensationList,
    CatalogCompensationForm,
    ValidationCampaignForm,
    SelectOwner
};

export interface Option {
    key: string;
    label: string;
    deep?: number;
    hidden?: boolean;
    tag?: boolean;
}

@Component({ components })
export default class List extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("getCurrentOwner") public currentOwner!: any;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    protected filters: object = {};
    protected userGuide: Document|null = null;
    private formVisible: boolean = false;
    private currentCatalogCompensationUuid: string|null = null;
    private currentYear: number = new Date().getFullYear();
    private optionsYear: any[] = [];
    private optionsCatalog: any[] = [];
    private optionsStore: any[] = [];
    private optionsStatus: any[] = [
        {key: "", label: "allStatus"},
        {key: Constants.catalogStatus.toValidate, label: Constants.catalogStatus.toValidate, tag: true},
        {key: Constants.catalogStatus.validated, label: Constants.catalogStatus.validated, tag: true},
        {key: Constants.catalogStatus.notValidated, label: Constants.catalogStatus.notValidated, tag: true},
    ];
    private exportDisabled: boolean = false;
    private optionsCompensationStrategy: Option[] = Constants.optionsCompensationStrategy;
    private campaignSelected: object[] = [];
    private validationCampaignFormVisible: boolean = false;
    private isAllCampaigns: boolean = false;
    public countCampaigns: number = 0;
    private globalBudget: number = 0;
    private hierarchyOwners: OptionOwner[] = [];

    @Watch("currentOwnerUuid") private refreshList(): void {
        this.buildStoreOptions();
        this.refreshOptions();
        this.loadUserGuide();
        _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
        EventBus.$emit(
            "update-filter",
            _.set(
                {},
                "forceReload",
                !_.get(this.filters, "forceReload", false)
            )
        );
        const params = { filters: this.filters};
        Http.get(
            "/countallcampaignstovalidate",
            params,
            (data: any) => {
                this.countCampaigns = data[0].catalogCount;
                this.globalBudget = data[0].globalBudget;
            },
            "errorLoadingCampaigns"
        );
        this.buildOptions();
    }
    @Watch("filters.year") private refreshYear(): void {
        this.buildCatalogOptions();
    }
    public mounted() {
        if (this.currentOwnerUuid) {
            this.buildStoreOptions();
            this.refreshOptions();
            this.buildOptions();
            this.loadUserGuide();
        }
        for (let i = 2023; i <= this.currentYear + 1; i++) {
            this.optionsYear.push({ key: i, label: i });
        }
        _.set(this.filters, "year", [this.currentYear]);
        _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
        EventBus.$on("catalog-status-updated", this.refreshList);
        EventBus.$on("mass-catalog-status-updated", this.handleMassCatalogStatusUpdated);
    }

    private refreshOptions(): void {
        _.set(this.filters, "parentOwner", "");
        _.set(this.filters, "subHierarchyOwner", "");
    }

    private loadUserGuide(): void {
        this.userGuide = null;
        let docComment = "zero_waste_user_guide";
        if (this.hasFeature("CONFIG_SOCLE")) {
            docComment = "socle_user_guide";
        }

        const paramsGetOwnerData = {
            fields: [
                "link",
                "clientOriginalFileName",
                "createdAt",
            ],
            filters: {
                comment: docComment,
                type: "user_guide",
            }
        };
        FileRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.userGuide = data[0] as Document;
        });
    }

    public beforeDestroy(): void {
        EventBus.$off("catalog-status-updated", this.refreshList);
        EventBus.$off("mass-catalog-status-updated", this.handleMassCatalogStatusUpdated);
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }

    private handleMassCatalogStatusUpdated() {
        this.campaignSelected = [];
        this.validationCampaignFormVisible = false;
        this.countCampaigns = 0;
    }

    private handleBudgetsUpdate() {
        this.refreshList();
    }

    private updateOwnerFilter(selectedOwner: string): void {
        EventBus.$emit("update-filter", _.set({}, "entityFilter", selectedOwner));
    }

    private showCatalogCompensationForm(operation: { uuid: string|null }) {
        this.currentCatalogCompensationUuid = operation.uuid;
        this.formVisible = true;
    }

    public get campaignAvailable(): undefined|any {
        return _.filter(this.campaignSelected, (campaign: any) => {
            return moment(campaign.validationDeadline).set("hour", 23).set("minute", 59).isAfter(moment()) &&
                campaign.isValidated === null;
        });
    }

    public get campaignExpired(): undefined|any {
        return _.filter(this.campaignSelected, (campaign: any) => {
            return moment(campaign.validationDeadline).set("hour", 23).set("minute", 59).isBefore(moment());
        });
    }

    public get campaignValidated(): undefined|any {
        return _.filter(this.campaignSelected, (campaign: any) => {
            return campaign.isValidated === true;
        });
    }

    public showValidationCampaignForm(
        campaigns: any, isAllCampaignsOrNot: boolean = false, countCampaigns: number = 0, globalBudget: number
    ) {
        this.validationCampaignFormVisible = true;
        this.globalBudget = 0;
        this.campaignSelected = [];
        this.isAllCampaigns = false;
        _.set(this, "campaignSelected", campaigns);

        if (isAllCampaignsOrNot) {
            this.isAllCampaigns = true;
            this.countCampaigns = countCampaigns;
            this.globalBudget = globalBudget;
            return;
        }

        const budgetKeys = [
            "crmBudget",
            "armisBudget",
            "pressBudget",
            "emailAcquisitionBudget",
            "affichageBudget",
            "factorElevenBudget"
        ];

        this.countCampaigns = 0;
        _.forEach(this.campaignAvailable, (filteredCampaign) => {

            this.countCampaigns++;
            budgetKeys.forEach((key) => {
                this.globalBudget += _.get(filteredCampaign, key, 0);
            });
        });
    }

    private buildCatalogOptions(): void {
        const paramsGetCatalogData = {
            fields: [
                "catalogName",
                "catalogCode"
            ],
            filters: {
                year: _.get(this.filters, "year"),
                listCatalog: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };

        CatalogCompensationRepository.get(paramsGetCatalogData).then((data: object[]) => {
            this.optionsCatalog = [];
            if (!_.find(this.optionsCatalog, (o) => o.label === "allCatalogs")) {
                this.optionsCatalog.push({key: "", label: "allCatalogs"});
            }
            _.forEach(data, (line) => {
                this.optionsCatalog.push({
                        key: _.get(line, "catalogCode"),
                        label: _.get(line, "catalogName") + " (" + _.get(line, "catalogCode") + ")"
                    });
            });
        });
    }

    private buildStoreOptions(): void {
        const paramsGetOwnerData = {
            fields: [
                "hierarchyOwner.uuid",
                "hierarchyOwner.dependentStatus"
            ],
            filters: {
                year: _.get(this.filters, "year"),
                listDependentStatus: true,
                ownerUuid: this.currentOwnerUuid,
            }
        };

        CatalogCompensationRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.optionsStore = [];

            this.optionsStore.push({key: "", label: "storeStatus"});

            _.forEach(data, (line) => {
                this.optionsStore.push({
                    key: _.get(line, "dependentStatus"),
                    label: _.get(line, "dependentStatus")
                });
            });
        });
    }

    private buildOptions(): void {

        const paramsGetOptionsData = {
            filters: {
                listOwner: true,
                ownerUuid: this.currentOwnerUuid
            }
        };
        CatalogCompensationRepository.get(paramsGetOptionsData).then((data: object[]) => {
            this.hierarchyOwners = data as OptionOwner[];
        });
    }

    private exportCatalogCompensation(): void {
        this.exportDisabled = false;
        const params = { filters: this.filters};
        Http.download(
            "/exportcatalogcompensation",
            params,
            (data: Blob) => {
                if (data.type === "text/plain") {
                    const url = window.URL.createObjectURL(data);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Export Compensation Catalogue.csv");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.exportDisabled = false;
                } else {
                  new Response(data).text().then((text: string) => {
                    this.$message({
                      message: _.invoke(this.$options.filters, "trans", text),
                      type: "warning"
                    });
                    this.exportDisabled = false;
                  });
                }
            },
            "errorDownloadDocument");
    }

    public downloadUserGuide(): void {
        this.download(this.userGuide as Document);
    }

    public download(documentDownloaded: Document) {
        FileRepository.download(documentDownloaded);
    }

    public get yearSelectSearchWidth(): string {
        return _.get(this.filters, "year", []).length > 1 ? "165px" : "125px";
    }
}
